import { Trash } from "@phosphor-icons/react";
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";

export function ConfirmDelete({ onConfirm, name, testid = "delete-btn", label = "Löschen", className }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          data-testid={testid}
          className={className || "flex items-center gap-1 text-xs font-semibold text-[#C0392B] transition-colors hover:text-[#a93226]"}
        >
          <Trash size={14} /> {label}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="max-w-[340px] rounded-2xl" data-testid="confirm-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Wirklich löschen?</AlertDialogTitle>
          <AlertDialogDescription>
            {name ? `„${name}" ` : "Dieser Eintrag "}wird dauerhaft entfernt. Das kann nicht rückgängig gemacht werden.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-delete-cancel">Abbrechen</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-delete-confirm" onClick={onConfirm} className="bg-[#C0392B] text-white hover:bg-[#a93226]">
            Löschen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
